import React, { createContext, useEffect, useState } from "react";

export const BasicContext = createContext({
    PID: "",//控制頁面顯示
    BID: "",//控制按鈕顯示
    ActType: "",
    ActID: "",
    Class1: "",
    Class2: "",
    openCard: false,
    cardList:[] as CardProps[]| undefined,    
    ansList:[] as ResAnswers[],
    ExamPaper:"",
    //LYearComplete:0,
    //RYearComplete:0,

    setPID: (pid: string) => { },
    setBID: (pid: string) => { },
    setActType: (actType: string) => { },
    setActID: (actType: string) => { },
    setClass1: (ID: string) => { }, 
    setClass2: (ID: string) => { },
    setOpenCard: (open: boolean) => { },
    setCardList: (list: CardProps[]| undefined) => { },
    setAnsList: (list: ResAnswers[]) => { },
    setExamPaper: (examPaper: string) => { },
    //setLYearComplete:(year:number):void=>{},
    //setRYearComplete:(year:number):void=>{},
    
});

export const BasicContextProvider = (props: any) => {
    const [PID, setMyPID] = useState<string>("");
    const [BID, setMyBID] = useState<string>("");
    const [ActType, setMyActType] = useState<string>("");
    const [ActID, setMyActID] = useState<string>("");
    const [Class1, setMyClass1] = useState<string>("");
    const [Class2, setMyClass2] = useState<string>("");
    const [openCard, setMyOpenCard] = useState<boolean>(false);
    const [cardlist, setMyCardlist] = useState<CardProps[]|undefined>(undefined);
    const [ansList, setMyAnsList] = useState<ResAnswers[]>([]);//問券回答的內容
    const [examPaper, setMyExamPaper] = useState<string>("");
    //const [LYearComplete, setLYearComplete] = useState<number>(0);
    //const [RYearComplete, setRYearComplete] = useState<number>(0);

    useEffect(() => {        
        const url: string = `
            ?${PID !=""?"pid="+PID:""}${examPaper !="" ?"&examPaper="+examPaper:""}${BID !="" ?"&bid="+BID:""}${ActType != "" ? "&type=" + ActType : ""}${Class1 != "" ? ("&Class1=" + Class1) : ""}${Class2 != "" ? ("&Class2=" + Class2) : ""}${ActID!= "" ? ("&actid=" + ActID) : ""}
        `
        window.history.replaceState("", "", url.trim());
        
    }, [PID, BID, ActType, Class1, Class2, ActID, examPaper])

    const setBasicPID = (pid: string) => {
        setMyPID(pid);
    };

    const setBasicBID = (pid: string) => {
        setMyBID(pid);
    };

    const setBasicActType = (actType: string) => {
        setMyActType(actType);
    };

    const setBasicActID = (actID: string) => {
       
        setMyActID(actID.toUpperCase());
    };

    const setBasicClass1 = (ID: string) => {
        setMyClass1(ID);
    };

    const setBasicClass2 = (ID: string) => {
        setMyClass2(ID);
    };

    const setBasicOpenCard = (open: boolean) => {
        setMyOpenCard(open);
    };

    const setBasicCardlist = (list: CardProps[]| undefined) => {
        setMyCardlist(list);
    };

    const setBasicAnsList = (list: ResAnswers[]) => {
        setMyAnsList(list);
    };

    const setBasicExamPaper = (examPaper:string) => {
        setMyExamPaper(examPaper);
    };
/*
    const setBasicLYearComplete = (year:number) => {
        setLYearComplete(year);
    };

    const setBasicRYearComplete = (year:number) => {
        setRYearComplete(year);
    };
*/
    return (
        <BasicContext.Provider
            value={{
                PID: PID,
                BID: BID,
                ActType: ActType,
                ActID: ActID,
                Class1: Class1,
                Class2: Class2,
                openCard: openCard,
                cardList: cardlist,
                ansList:ansList,
                ExamPaper:examPaper,
                //LYearComplete:LYearComplete,
                //RYearComplete:RYearComplete,
            
                setPID: setBasicPID,
                setBID: setBasicBID,
                setActType: setBasicActType,
                setActID: setBasicActID,
                setClass1: setBasicClass1,
                setClass2: setBasicClass2,
                setOpenCard: setBasicOpenCard,
                setCardList: setBasicCardlist,
                setAnsList: setBasicAnsList,
                setExamPaper: setBasicExamPaper,
                //setLYearComplete:setBasicLYearComplete,
                //setRYearComplete:setBasicRYearComplete

            }}>
            {props.children}
        </BasicContext.Provider>
    )
}


